<template>
  <div class="text-center">
    <v-dialog persistent v-model="showModal" width="800" transition="dialog-bottom-transition">
      <v-card class="elevation-0">
        <v-card-title class="headline primary white--text">
          Update case
          <v-spacer></v-spacer>
          <v-btn icon @click="$parent.toggleEditCaseDialog()" right text fab small color="white"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-form v-model="formValid" ref="form-selected-subject-case" class="form-selected-subject-case">
          <v-alert type="error" v-if="formError" dense dismissible class="mt-0"> Please fill in all required fields </v-alert>
          <v-spacer></v-spacer>
          <!-- title personal info -->
          <v-row class="rowstyle">
            <v-col class="filter-col" cols="12" md="10" offset-md="1">
              <label class="primary--text title"> Personal Info: </label>
            </v-col>
          </v-row>

          <!-- name/last name -->
          <v-row class="rowstyle">
            <v-col class="filter-col" cols="12" md="5" offset-md="1">
              <v-text-field
                v-model="formData.firstname"
                :rules="[(v) => !!v || 'This field is required']"
                class="required"
                label="First name"
                required
              ></v-text-field>
            </v-col>
            <v-col class="filter-col" cols="12" md="5">
              <v-text-field
                v-model="formData.lastname"
                :rules="[(v) => !!v || 'This field is required']"
                class="required"
                label="Last name"
                required
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- azv number / doctor -->
          <v-row class="rowstyle">
            <v-col class="filter-col" cols="12" md="5" offset-md="1">
              <v-text-field
                v-model="formData.azvNumber"
                label="AZV Number"
                :loading="checkingAzvNumber"
                :disabled="checkingAzvNumber"
                @input="validateAzvNumberFunctionLocal($event)"
                type="text"
                :error-messages="errorAzvAreadyInUse"
                :rules="[(v) => validateAzvNumberLocal || !v || 'AZV number not valid']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-autocomplete
                clearable
                :disabled="doctorOptions.length == 0"
                :loading="doctorOptions.length == 0"
                v-model="formData.doctorEntry.id"
                data-lpignore="true"
                :items="doctorOptions"
                label="Doctor"
              >
              </v-autocomplete>
            </v-col>
          </v-row>

          <!-- birthday and country -->
          <v-row class="rowstyle">
            <v-col class="filter-col" cols="12" md="5" offset-md="1">
              <BirthDayPicker keyName="birthDay" :valueFromParent="formData.birthDay" :required="false" @updateParentValue="updateValue" />
            </v-col>

            <v-col class="filter-col" cols="12" md="5">
              <v-text-field
                v-model="formData.email"
                :rules="emailRules"
                label="Email"
                type="email"
                class="required"
                required
                hint="john.doe@mail.com"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="dividervisibility"> </v-divider>

          <v-row class="mt-3 rowstyle">
            <v-spacer></v-spacer>
            <v-card-actions class="mb-3">
              <v-btn
                class="savebtnpos"
                color="primary"
                @click="saveCaseChanges()"
                :disabled="checkingAzvNumber || savingCaseChanges || !changesMade"
                :loading="checkingAzvNumber || savingCaseChanges"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BirthDayPicker from '@/components/form-components/birthday-picker.vue';
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import { validateAzvNumber } from '@/utils/shared-functions-vanilla.js';

export default {
  mixins: [SharedFunctions],
  props: ['formDataParent', 'newCase', 'withParentLink', 'showModal'],
  components: {
    BirthDayPicker
  },
  computed: {
    ...mapGetters('accountSearchStore', ['accountData', 'caseSelectedData', 'accountEditDelay']),
    ...mapGetters('doctorOptionsStore', ['getDoctorOptions']),
    formDataString() {
      return JSON.stringify(this.formData);
    },
    doctorOptions() {
      return this.$store.state.doctorOptionsStore.doctorOptions;
    },
    changesMade() {
      return (
        this.formData.firstname !== this.formDataParent.firstname ||
        this.formData.lastname !== this.formDataParent.lastname ||
        this.formData.azvNumber !== this.formDataParent.azvNumber ||
        this.formData.birthDay !== this.formDataParent.birthDay ||
        this.formData.email !== this.formDataParent.email ||
        this.formData.doctorEntry.id !== this.formDataParent.doctorEntry?.id
      );
    }
  },
  data() {
    return {
      dataLoaded: false,
      formError: false,
      showEditAlert: false,
      formValid: null,
      validateAzvNumberLocal: true,
      azvNumberCache: null,
      checkingAzvNumber: false,
      savingCaseChanges: false,
      errorAzvAreadyInUse: null,
      states: [],
      maxCommentChars: 250,
      rulesComment: [(v) => v == '' || v == null || (v && v.length <= this.maxCommentChars) || `Max ${this.maxCommentChars} characters`],
      emailRules: [(v) => /.+@.+\..+/.test(v) || 'E-mail must be valid', (v) => this.checkForDotEmail(v)],
      rulesAddress: [(v) => !!v || 'This field is required'],
      formData: {
        userId: null,
        keycloakId: null,
        name: 'Case ' + Math.floor(1000 + Math.random() * 9000),
        firstname: null,
        lastname: null,
        birthDay: null,
        state: null,
        azvCardNumber: null,
        email: null,
        doctorEntry: {
          id: null
        }
      }
    };
  },
  created() {
    //get doctors
    if (this.doctorOptions.length == 0) {
      this.$store.dispatch('doctorOptionsStore/fetchDoctorOptions');
    }
    this.loadData();
  },
  methods: {
    validateAzvNumber,
    loadData() {
      if (this.formDataParent) {
        this.formData = this.prepareParentData(this.formDataParent);
        //cache azv number for edit validation
        if (this.formData.azvCardNumber || this.formData.azvNumber) this.azvNumberCache = this.formData.azvCardNumber || this.formData.azvNumber;

        setTimeout(() => {
          this.dataLoaded = true;
        }, 0);
      } else {
        this.formData.userId = this.accountData.keycloakEmail;
        this.formData.keycloakId = this.accountData.keycloakId;
        this.dataLoaded = true;
      }
    },
    updateValue(value, keyName) {
      if (this.formData[keyName] === undefined) {
        this.$set(this.formData, keyName, null);
      }
      this.formData[keyName] = value;
    },
    saveCaseChanges() {
      const dataToPost = this.cleanUpData(this.formData);
      delete dataToPost.patientTestKit;
      this.formError = false;
      if (this.$refs['form-selected-subject-case'].validate() && !this.errorAzvAreadyInUse) {
        this.savingCaseChanges = true;
        this.$store.commit('SET_SHOW_LOADER', { action: true, text: 'Editing case....' });
        this.$store
          .dispatch('accountSearchStore/updateCase', dataToPost)
          .then(() => {
            this.showEditAlert = false;
            this.azvNumberCache = this.formData.azvNumber;
            // this.$store.dispatch('getStateHistory', this.caseSelectedData.id);
            this.$store.commit('accountSearchStore/SET_ACCOUNT_UPDATED', true);
            this.$parent.toggleEditCaseDialog();
            this.$emit('caseUpdated');
          })
          .catch(() => {
            this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
          })
          .finally(() => {
            setTimeout(() => {
              this.savingCaseChanges = false;
              this.$store.commit('SET_SHOW_LOADER', { action: false, text: null });
            }, this.accountEditDelay);
          });
      } else {
        this.formError = true;
        this.clearFilter();
      }
    },
    clearFilter() {
      const columns = document.querySelectorAll('.filter-col');
      for (var i = 0; i < columns.length; i++) {
        columns[i].classList.remove('hide');
      }
    },
    validateAzvNumberFunctionLocal(value) {
      if (validateAzvNumber(value)) {
        this.validateAzvNumberLocal = true;
        // this.checkAzvExists(value);
      } else if (value == '') {
        this.validateAzvNumberLocal = true;
        this.errorAzvAreadyInUse = null;
      } else {
        this.validateAzvNumberLocal = false;
      }
    },
    checkAzvExists(value) {
      if (this.azvNumberCache != value) {
        this.checkingAzvNumber = true;
        if (this.newCase) this.$parent.$parent.$parent.$parent.checkingAzvNumber = true;
      } else this.errorAzvAreadyInUse = null;
    },
    prefillOriginAndEdCard() {
      this.formData.edCardId = 'PAPER_SELF_REGISTER_LOCAL';
      this.formData.countryResidency = 'ARUBA_LOCAL';
    },
    prepareParentData(parentData) {
      parentData = JSON.parse(JSON.stringify(parentData));
      if (!parentData.doctorEntry) {
        parentData.doctorEntry = {
          id: null
        };
      }
      return parentData;
    },
    cleanUpData(data) {
      data = JSON.parse(JSON.stringify(data));
      if (data.vaccine) delete data.vaccine;
      if (!data.doctorEntry?.id) delete data.doctorEntry;

      return data;
    }
  }
};
</script>

<style lang="scss">
.form-selected-subject-case {
  .title-border {
    border: 1px solid #366baf !important;
  }
  .edCardId-display {
    font-size: 14px;
    // margin-bottom: 3px;
    // //background: whitesmoke;
    // color: grey;
    // padding: 2px 10px;
    .label {
      color: grey;
    }
  }
}

.savebtnpos {
  margin-right: 5em;
}

.rowstyle {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

@media only screen and (max-width: 960px) {
  .savebtnpos {
    margin-right: 4px;
  }
  .dividervisibility {
    display: none;
  }
}
</style>
